import React, { useEffect, Suspense, lazy } from 'react';
import NavBar from './components/layout/NavBar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import SmoothScroll from './components/ui/SmoothScroll';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

const HomePage = lazy(() => import('./pages/HomePage'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const HostingPage = lazy(() => import('./pages/HostingPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const SupportPage = lazy(() => import('./pages/SupportPage'));
const SoonPage = lazy(() => import('./pages/SoonPage'));
const StatusPage = lazy(() => import('./pages/StatusPage'));


function App() {
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const parallaxElements = document.querySelectorAll('.parallax');

      parallaxElements.forEach(element => {
        const speed = element.getAttribute('data-speed') || 0.2;
        element.style.transform = `translateY(${scrollY * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
      <Router>
        <ScrollToTop />
        <SmoothScroll />
        <div className="flex flex-col min-h-screen bg-black text-white w-full overflow-x-hidden">
          <NavBar />
          <div className="flex-grow w-full">
            <Suspense fallback={<div className="min-h-screen bg-black" />}>
              <Routes>
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/hosting" element={<HostingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="/projects" element={<SoonPage />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/status" element={<StatusPage />} />
                <Route path="/ai" element={<SoonPage title="XfeaturesAI" />} />
                <Route path="/guard" element={<SoonPage title="XfeaturesGUARD" />} />
                <Route path="/api" element={<SoonPage title="XfeaturesAPI" />} />
                <Route path="*" element={<SoonPage title="404 Not Found" />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </Router>
  );
}

export default App;